import type { CalendarItemDto } from '@ukinfo/shared';
import { formatTime } from '../lib/format';

export function dayKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function CalendarMonth({ month, items, onOpen }: {
  month: Date; items: CalendarItemDto[]; onOpen: (item: CalendarItemDto) => void;
}): JSX.Element {
  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const offset = (first.getDay() + 6) % 7;
  const days = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
  const cells = Math.ceil((offset + days) / 7) * 7;
  return <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
    <div className="grid min-w-[560px] grid-cols-7" aria-label="Monatskalender">
      {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map((day) => <div key={day} className="border-b p-2 text-center text-xs font-semibold text-slate-500">{day}</div>)}
      {Array.from({ length: cells }, (_, index) => {
        const date = new Date(month.getFullYear(), month.getMonth(), index - offset + 1);
        const next = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
        const key = dayKey(date);
        const today = key === dayKey(new Date());
        const entries = items.filter((item) => Date.parse(item.startAt) < next.getTime() &&
          (item.endAt && Date.parse(item.endAt) > Date.parse(item.startAt) ? Date.parse(item.endAt) > date.getTime() : Date.parse(item.startAt) >= date.getTime()));
        return <div key={key} className={`min-h-28 border-b border-r p-1.5 ${date.getMonth() !== month.getMonth() ? 'bg-slate-50 text-slate-400' : ''}`}>
          <time dateTime={key} className={`mb-1 inline-flex h-6 w-6 items-center justify-center rounded-full text-xs ${today ? 'bg-brand-600 font-bold text-white' : ''}`}>{date.getDate()}</time>
          <div className="space-y-1">{entries.map((item) => <button key={item.id} type="button" onClick={() => onOpen(item)} title={`${item.title}${item.location ? ` · ${item.location}` : ''}`}
            className={`block w-full rounded px-1.5 py-1 text-left text-xs leading-snug ${item.kind === 'TASK' ? 'bg-amber-50 text-amber-900' : item.kind === 'BIRTHDAY' ? 'bg-pink-50 text-pink-800' : 'bg-brand-50 text-brand-800'} hover:ring-1 hover:ring-brand-400`}>
            {!item.allDay && <span className="font-semibold">{formatTime(item.startAt)} </span>}{item.title}
          </button>)}</div>
        </div>;
      })}
    </div>
  </div>;
}
